// extracted by mini-css-extract-plugin
export default {"titles":"Titles_titles__GGUzc"};